import React from 'react';
import { Link } from 'react-router-dom';
export function Careers() {
  return <div className="max-w-4xl mx-auto px-6 pt-32 pb-24" data-id="element-2578">
      <div className="mb-16" data-id="element-2579">
        <h1 className="text-4xl font-bold text-white mb-4 font-title" data-id="element-2580">
          Join Giga
        </h1>
        <p className="text-neutral-400 font-body text-lg max-w-2xl" data-id="element-2581">
          We're building an AI assistant platform that connects to every tool
          your team uses. Help us build the future of work.
        </p>
      </div>

      <div className="space-y-12" data-id="element-2582">
        {/* Principal Engineer */}
        <div className="bg-neutral-900/40 border border-neutral-800 rounded-2xl p-5 md:p-8" data-id="element-2583">
          <div className="flex flex-col md:flex-row md:items-start justify-between gap-6 mb-6" data-id="element-2584">
            <div data-id="element-2585">
              <h2 className="text-2xl font-bold text-white mb-2" data-id="element-2586">
                Principal Engineer
              </h2>
              <div className="flex items-center gap-3 text-sm text-neutral-400" data-id="element-2587">
                <span className="px-2.5 py-1 rounded-md bg-neutral-800/50 border border-neutral-700/50" data-id="element-2588">
                  Engineering
                </span>
                <span data-id="element-2589">•</span>
                <span data-id="element-2590">Remote</span>
                <span data-id="element-2591">•</span>
                <span data-id="element-2592">Full-time</span>
              </div>
            </div>
            <Link to="/contact" className="px-6 py-2.5 bg-white text-[#333333] font-medium rounded-lg hover:bg-neutral-200 transition-colors text-center shrink-0" data-id="element-2593">
              Apply Now
            </Link>
          </div>

          <div className="space-y-6 text-neutral-300 font-body leading-relaxed" data-id="element-2594">
            <p data-id="element-2595">
              We're looking for a hands-on, senior IC to lead backend
              architecture and systems engineering at Giga. Our product is built
              on Linux VMs (not containers), and uses a custom coding harness
              that interacts directly with operating system primitives.
            </p>

            <div data-id="element-2596">
              <h3 className="text-white font-semibold mb-3" data-id="element-2597">What you'll do:</h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-2598">
                <li data-id="element-2599">
                  Architect and maintain our core backend infrastructure built
                  primarily in Ruby.
                </li>
                <li data-id="element-2600">
                  Manage and optimize our Linux VM fleet and sysadmin
                  operations.
                </li>
                <li data-id="element-2601">
                  Build and secure the coding harness that allows our AI agents
                  to execute code safely.
                </li>
                <li data-id="element-2602">
                  Navigate and simplify non-straightforward architectural
                  challenges.
                </li>
              </ul>
            </div>

            <div data-id="element-2603">
              <h3 className="text-white font-semibold mb-3" data-id="element-2604">
                What we're looking for:
              </h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-2605">
                <li data-id="element-2606">
                  Deep expertise in Ruby and backend systems architecture.
                </li>
                <li data-id="element-2607">
                  Strong Linux sysadmin skills and experience managing VM-based
                  infrastructure.
                </li>
                <li data-id="element-2608">
                  Experience with systems programming and OS-level primitives.
                </li>
                <li data-id="element-2609">
                  Comfortable working in complex, non-standard architectures.
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Head of Product */}
        <div className="bg-neutral-900/40 border border-neutral-800 rounded-2xl p-5 md:p-8" data-id="element-2610">
          <div className="flex flex-col md:flex-row md:items-start justify-between gap-6 mb-6" data-id="element-2611">
            <div data-id="element-2612">
              <h2 className="text-2xl font-bold text-white mb-2" data-id="element-2613">
                Head of Product
              </h2>
              <div className="flex items-center gap-3 text-sm text-neutral-400" data-id="element-2614">
                <span className="px-2.5 py-1 rounded-md bg-neutral-800/50 border border-neutral-700/50" data-id="element-2615">
                  Product
                </span>
                <span data-id="element-2616">•</span>
                <span data-id="element-2617">Remote</span>
                <span data-id="element-2618">•</span>
                <span data-id="element-2619">Full-time</span>
              </div>
            </div>
            <Link to="/contact" className="px-6 py-2.5 bg-white text-[#333333] font-medium rounded-lg hover:bg-neutral-200 transition-colors text-center shrink-0" data-id="element-2620">
              Apply Now
            </Link>
          </div>

          <div className="space-y-6 text-neutral-300 font-body leading-relaxed" data-id="element-2621">
            <p data-id="element-2622">
              We're looking for a product leader to help us build and maintain a
              software factory where we go from idea to production in less than
              24 hours. You'll shape the direction of our AI assistant platform
              for teams.
            </p>

            <div data-id="element-2623">
              <h3 className="text-white font-semibold mb-3" data-id="element-2624">What you'll do:</h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-2625">
                <li data-id="element-2626">
                  Lead product strategy and execution for the Giga platform.
                </li>
                <li data-id="element-2627">
                  Drive our rapid iteration cycle (idea to production in
                  &lt;24h).
                </li>
                <li data-id="element-2628">
                  Work closely with engineering to define and prioritize
                  features.
                </li>
                <li data-id="element-2629">
                  Get your hands dirty — this is a builder role, not just
                  high-level strategy.
                </li>
              </ul>
            </div>

            <div data-id="element-2630">
              <h3 className="text-white font-semibold mb-3" data-id="element-2631">
                What we're looking for:
              </h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-2632">
                <li data-id="element-2633">
                  You are already AI-native / AI-pilled and deeply understand
                  the current LLM landscape.
                </li>
                <li data-id="element-2634">
                  Proven experience shipping complex B2B SaaS products rapidly.
                </li>
                <li data-id="element-2635">
                  Willingness to be hands-on in a fast-paced startup
                  environment.
                </li>
                <li data-id="element-2636">Strong product intuition and user empathy.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>;
}